export default "##### Radius Rings Trade Area\n--- \n";